import { array, partial } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';

export const Request = partial({
	organizationIds: array(OrganizationId),
});
